import React from 'react';

import { useCommunitiesCountQuery, useCommunitiesQuery } from 'generated/graphql';
import { EntityTable } from 'components/TeamsCommunities/EntityTable';
import config from 'config';

export const CommunitiesList = (): JSX.Element => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const communitiesQuery = useCommunitiesQuery({
    variables: {
      skip: page * rowsPerPage,
      take: rowsPerPage,
      where: { type: { equals: 'Community' } },
    } as any,
  });

  const communitiesCountQuery = useCommunitiesCountQuery({
    variables: {
      where: { type: { equals: 'Community' } },
    } as any,
  });

  const communities = communitiesQuery.data?.communities;
  const communitiesCount = communitiesCountQuery.data?.communitiesCount;

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  return (
    <EntityTable
      entities={communities || []}
      entityTypeFromUrl="communities"
      loading={communitiesQuery.loading || communitiesCountQuery.loading}
      page={page}
      rowsPerPage={rowsPerPage}
      totalCount={communitiesCount || 0}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
      clientUrl={config.clientUrl}
    />
  );
};
